import React from 'react';

const PresetsSection = () => {
  const presets = [
    {
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/bjk4l0p6_prp.png',
      title: 'PRP',
      description: 'Optimize platelet-rich plasma for enhanced growth factor release and superior regenerative outcomes'
    },
    {
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/vvdf01p6_cells.png',
      title: 'Cells',
      description: 'Activate cellular performance and maximize therapeutic potential through precise biomodulation'
    },
    {
      icon: 'https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/p868q9tz_exsososme.png',
      title: 'Exosomes',
      description: 'Stimulate natural exosome production for advanced cellular communication and regeneration'
    }
  ];

  return (
    <section className="relative py-32 px-6 overflow-hidden">
      {/* Animated background with silhouette */}
      <div className="absolute inset-0 z-0">
        <div 
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_celltech-showcase/artifacts/9rg7vdma_Silueta.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-white via-teal-50/30 to-white"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section header */}
        <div className="text-center mb-20 animate-fade-in">
          <span className="inline-block text-teal-500 font-medium text-sm tracking-wider uppercase mb-4">
            Versatile Technology
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6" style={{ fontFamily: 'Raleway, sans-serif' }}>
            The MCT <span className="text-teal-500 font-normal">Presets</span>
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            Three specialized programs designed to optimize different autologous materials
          </p>
        </div>

        {/* Presets grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {presets.map((preset, index) => (
            <div
              key={index}
              className="group relative bg-white/90 backdrop-blur-sm rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all duration-500 hover:-translate-y-3 border border-teal-100/50"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Icon container */}
              <div className="flex justify-center mb-8">
                <div className="w-32 h-32 flex items-center justify-center bg-gradient-to-br from-teal-50 to-white rounded-2xl p-4 group-hover:scale-110 group-hover:rotate-3 transition-all duration-500 shadow-soft">
                  <img 
                    src={preset.icon} 
                    alt={preset.title}
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>

              {/* Content */}
              <h3 className="text-2xl md:text-3xl font-light text-center text-gray-900 mb-4 group-hover:text-teal-600 transition-colors duration-300">
                {preset.title}
              </h3>
              <p className="text-gray-600 font-light text-center leading-relaxed">
                {preset.description}
              </p>

              {/* Animated bottom accent */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 via-teal-500 to-teal-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-700 rounded-b-3xl"></div>
              
              {/* Hover glow effect */}
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-teal-400/0 to-teal-500/0 group-hover:from-teal-400/5 group-hover:to-teal-500/10 transition-all duration-500 -z-10"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PresetsSection;
